<div class="request-links-component">
    <h3 class="section-title">{{ 'request_v2.links.title' | translate }}</h3>

    <div class="links-container">
        <div class="link-card" *ngFor="let link of links" [class.active-dropdown-card]="openDropdownId === getLinkedRequestId(link)">
            <div class="delete-confirmation" *ngIf="linkToDelete === link">
                <div class="confirmation-content">
                    <div class="confirm-title">{{ 'request_v2.links.remove_association.title' | translate }}</div>
                    <div class="confirm-text">{{ 'request_v2.links.remove_association.text' | translate: { requestId: link.linkedRequest.requestId } }}</div>
                </div>
                <div class="confirmation-actions">
                    <button class="btn-text" (click)="cancelDelete()">{{ 'common.cancel' | translate }}</button>
                    <button class="btn-danger" (click)="deleteLink()">{{ 'request_v2.links.remove' | translate }}</button>
                </div>
            </div>

            <div class="link-content" *ngIf="linkToDelete !== link">
                <div class="link-type-section">
                    <div class="custom-dropdown" (click)="toggleDropdown(getLinkedRequestId(link)); $event.stopPropagation()">
                        <span class="current-value">{{ getLabelForType(link.type) | translate | uppercase }}</span>
                        <mat-icon>keyboard_arrow_down</mat-icon>

                        <div class="dropdown-options" *ngIf="openDropdownId === getLinkedRequestId(link)">
                            <div class="option" *ngFor="let type of linkTypes" (click)="$event.stopPropagation(); onLinkTypeChange(link, type.value)">
                                {{ type.label | translate | uppercase }}
                            </div>
                        </div>
                    </div>
                </div>

                <div class="link-details-section">
                    <div class="details-top">
                        <span class="request-id">{{ link.linkedRequest.requestId }}</span>
                        <span class="status-badge" [style.background-color]="getStatus(link.linkedRequest)?.color || '#ccc'">
                            {{ getStatusLabel(getStatus(link.linkedRequest)) | uppercase }}
                        </span>
                        <div class="spacer"></div>
                        <button class="close-icon" (click)="confirmDelete(link)">&times;</button>
                    </div>
                    <div class="details-bottom">
                        <span class="category-info">
                            {{ getRequestCategoryLabel(link.linkedRequest) }}
                            <span class="sep">|</span>
                            {{ link.linkedRequest.department?.name }}
                        </span>
                        <span class="user-info" *ngIf="link.linkedRequest.user">
                            <ng-container *ngIf="link.linkedRequest.user.picture; else defaultInitials">
                                <span class="user-avatar" [style.background-image]="'url(' + link.linkedRequest.user.picture + ')'"></span>
                            </ng-container>
                            <ng-template #defaultInitials>
                                <div class="user-initials">
                                    {{ link.linkedRequest.user.firstName?.charAt(0) }}{{ link.linkedRequest.user.lastName?.charAt(0) }}
                                </div>
                            </ng-template>
                            <span class="user-name">{{ link.linkedRequest.user.firstName }} {{ link.linkedRequest.user.lastName }}</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="add-link-section">
        <div class="add-btn-wrapper" *ngIf="!isLinking">
            <button class="add-link-btn" (click)="startLinking()">
                <mat-icon>add</mat-icon> {{ 'request_v2.links.add_link' | translate }}
            </button>
        </div>

        <div class="link-form" *ngIf="isLinking">
            <div class="form-inputs">
                <div class="type-selector">
                    <div class="custom-select-wrapper">
                        <select [(ngModel)]="newLinkType">
                            <option *ngFor="let type of linkTypes" [value]="type.value">{{ type.label | translate }}</option>
                        </select>
                        <mat-icon class="select-icon">keyboard_arrow_down</mat-icon>
                    </div>
                </div>

                <div class="search-input-wrapper">
                    <mat-icon class="search-icon">search</mat-icon>

                    <mat-progress-spinner class="loading-icon" *ngIf="isSearching" mode="indeterminate" diameter="20"></mat-progress-spinner>
                    <mat-icon class="clear-icon" *ngIf="!isSearching && searchTerm" (click)="clearSearch()">close</mat-icon>

                    <input
                        type="text"
                        [(ngModel)]="searchTerm"
                        (ngModelChange)="onSearch($event)"
                        [placeholder]="'request_v2.links.search_placeholder' | translate"
                        autofocus
                    >

                    <div class="autocomplete-results" *ngIf="searchResults.length > 0 || (searchTerm.length >= 2 && !isSearching)">
                        <div class="result-item" *ngFor="let result of searchResults" (click)="selectRequestToLink(result)">
                            <div class="res-row-1">
                                <span class="res-id">{{ result.requestId }}</span>
                                <span class="res-status" [style.background-color]="getStatus(result)?.color || '#ccc'">
                                    {{ getStatusLabel(getStatus(result)) | uppercase }}
                                </span>
                            </div>
                            <div class="res-row-2">
                                <span class="res-cat">{{ result.subCategory?.name || result.category?.name }}</span>
                                <span class="res-desc" *ngIf="result.category?.description">&bull; {{ result.category?.description }}</span>
                            </div>
                            <div class="res-row-3">
                                <span class="res-dept">{{ result.department?.name }}</span>
                                <span class="res-user" *ngIf="result.user">
                                    <span class="dot">&bull;</span>
                                    <div class="mini-avatar" *ngIf="result.user.picture" [style.background-image]="'url(' + result.user.picture + ')'"></div>
                                    <span class="mini-initials" *ngIf="!result.user.picture">{{ result.user.firstName?.charAt(0) }}{{ result.user.lastName?.charAt(0) }}</span>
                                    {{ result.user.firstName }} {{ result.user.lastName }}
                                </span>
                            </div>
                        </div>

                        <div class="no-results" *ngIf="searchResults.length === 0 && !isSearching">
                            {{ 'request_v2.links.no_results' | translate: { searchTerm: searchTerm } }}
                        </div>
                    </div>
                </div>
            </div>
            <div class="form-footer">
                <button class="btn-cancel" (click)="cancelLinking()">{{ 'common.cancel' | translate }}</button>
            </div>
        </div>
    </div>
</div>
